<template>
    <div>
        <v-tooltip bottom v-if="status===1">
            <template v-slot:activator="{ on }">
              <v-btn icon  v-on="on">
                <v-icon color="green" size="25">mdi-check-circle</v-icon>
              </v-btn>
            </template>
            <span>Approved</span>
        </v-tooltip>
        <v-tooltip bottom v-else-if="status===2 || status === 0">
            <template v-slot:activator="{ on }">
              <v-btn icon  v-on="on">
                <v-icon color="orange" size="25">error</v-icon>
              </v-btn>
            </template>
            <span>Applied/Pending</span>
        </v-tooltip>
        <v-tooltip bottom v-else-if="status===3">
            <template v-slot:activator="{ on }">
              <v-btn icon  v-on="on">
                <v-icon color="red" size="25">mdi-close-circle</v-icon>
              </v-btn>
            </template>
            <span>Rejected</span>
        </v-tooltip>
        <v-tooltip bottom v-else-if="status===4">
            <template v-slot:activator="{ on }">
              <v-btn icon  v-on="on">
                <v-icon color="red" size="25">mdi-close-circle</v-icon>
              </v-btn>
            </template>
            <span>Inactive</span>
        </v-tooltip>
    </div>
</template>

<script>
    export default {
        name: "ListItemDetail",
        props: {
            status: {
                type: [Number],
                default: null,
            },
        },
        methods: {
            actionClick() {
                this.$emit('actionClick')
            }
        }
    }
</script>

